import React, { useEffect } from "react";
import { PageWrapper } from "@adl/smart-ui-library";
import PageFooter from "@/components/PageFooter";
import { useNavigate } from "react-router-dom";

type Props = {
  paddingTop?: number;
  testId?: string;
  children: React.ReactElement;
};

const DefaultTemplate = ({
  children,
  paddingTop,
  testId = "page-warpper",
}: Props) => {
  const navigate = useNavigate();
  useEffect(() => {
    const currentPath = window.location.pathname;
    if (currentPath === "/tasks") {
      navigate("/tasks");
    }
  }, []);

  return (
    <PageWrapper
      testId={testId}
      debug={import.meta.env.DEV}
      topPadding={paddingTop || 100}
    >
      {children}
      <PageFooter />
    </PageWrapper>
  );
};

export default DefaultTemplate;
